import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconHome: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconHome"><Path fillRule="evenodd" clipRule="evenodd" d="M10.2586 1.95572C11.2716 1.1269 12.7284 1.1269 13.7414 1.95572L19.9914 7.06936C20.6298 7.59167 21 8.37293 21 9.19774V18.25C21 19.7688 19.7688 21 18.25 21H5.75C4.23122 21 3 19.7688 3 18.25V9.19774C3 8.37293 3.37022 7.59167 4.0086 7.06936L10.2586 1.95572Z" fill="currentColor"/></CentralIconBase>;
});

export default IconHome;
